import { Player } from "./Player";

const NoneIcon = "https://slippi.gg/static/media/rank_Unranked1.ac2623299b250689293cd4a5e68fcc5b.svg";
const PendingIcon = "https://slippi.gg/static/media/rank_Unranked3.0f639e8b73090a7ba4a50f7bcc272f57.svg";
const Bronze1Icon = "https://slippi.gg/static/media/rank_Bronze_I.90480ec5a08ee8d6048021f889933455.svg";
const Bronze2Icon = "https://slippi.gg/static/media/rank_Bronze_II.9d7a7994dbf087e3aea44f5b1c1409a7.svg";
const Bronze3Icon = "https://slippi.gg/static/media/rank_Bronze_III.b44c3a06f14234dec6f67e9b28088a6f.svg";
const Silver1Icon = "https://slippi.gg/static/media/rank_Silver_I.b8069dd847a639127f6d3ff5363623f7.svg";
const Silver2Icon = "https://slippi.gg/static/media/rank_Silver_II.7a97ee32770c36e78d9d7e9279c7ce38.svg";
const Silver3Icon = "https://slippi.gg/static/media/rank_Silver_III.93588af0e9a6bc9406209d5ef3cc9dc7.svg";
const Gold1Icon = "https://slippi.gg/static/media/rank_Gold_I.523b488f06ff22aaa013e94b6178f157.svg";
const Gold2Icon = "https://slippi.gg/static/media/rank_Gold_II.951fc625063425ed048c864988e8d7b7.svg";
const Gold3Icon = "https://slippi.gg/static/media/rank_Gold_III.38643ad9dbef534920fc2361fd736d7a.svg";
const Platinum1Icon = "https://slippi.gg/static/media/rank_Platinum_I.7a22c1a7c7640af6b6bf2f7b5b439fc6.svg";
const Platinum2Icon = "https://slippi.gg/static/media/rank_Platinum_II.ec1c571c896ed47ef2b14d8e2dd79fef.svg";
const Platinum3Icon = "https://slippi.gg/static/media/rank_Platinum_III.cd9d7a413a1de2182caaae563b4e5023.svg";
const Diamond1Icon = "https://slippi.gg/static/media/rank_Diamond_I.bcc6237a1e6be861f22f330bbff96964.svg";
const Diamond2Icon = "https://slippi.gg/static/media/rank_Diamond_II.2f26cd8248bcf6c34ea1efe7f835b123.svg";
const Diamond3Icon = "https://slippi.gg/static/media/rank_Diamond_III.ae3a5720a6ed48594efef54249095001.svg";
const Master1Icon = "https://slippi.gg/static/media/rank_Master_I.0ce2459fedf9e33ebee0cb3520a17e2f.svg";
const Master2Icon = "https://slippi.gg/static/media/rank_Master_II.c0b5472d49d391d2063d8e2a19c9ea17.svg";
const Master3Icon = "https://slippi.gg/static/media/rank_Master_III.5075fd077bf77bfa6c59985252e0cb04.svg";
const GrandMasterIcon = "https://slippi.gg/static/media/rank_Grand_Master.0f3bc5674e8ec76f17514f197242c4fa.svg";

interface Rank {
    isRank(player: Player): boolean;
    name: string;
    bgClass: string;
    iconUrl?: string;
}
class NoneRank implements Rank {
    public name = "None";
    public iconUrl = NoneIcon;
    public bgClass = "bg-stone-500";

    isRank(player: Player) {
        return setCount(player) === 0;
    }
}

const setCount = (player: Player) => {
    return player.rankedNetplayProfile.wins +
        player.rankedNetplayProfile.losses;
};

const MIN_RANK_SETS = 5;

class PendingRank implements Rank {
    public name = "Pending";
    public iconUrl = PendingIcon;
    public bgClass = "bg-stone-700";

    isRank(player: Player) {
        const totalSets = setCount(player);
        return 0 < totalSets && totalSets < MIN_RANK_SETS;
    }
}

class StandardRank implements Rank {
    constructor(
        public name: string,
        private lowerBound: number,
        private upperBound: number,
        public bgClass: string,
        public iconUrl?: string,
    ) { }

    isRank(player: Player) {
        if (setCount(player) < MIN_RANK_SETS)
        {
            return false;
        }
        const rating = player.rankedNetplayProfile.ratingOrdinal;
        return this.lowerBound <= rating && rating <= this.upperBound;
    }
}

class GrandMaster extends StandardRank {
    constructor() {
        super('Grandmaster', 2191.75, Infinity, "bg-slate-900", GrandMasterIcon);
    }

    isRank(player: Player) {
        const hasRating = super.isRank(player);
        if (!hasRating)
        {
            return false;
        }
        return player.rankedNetplayProfile.dailyGlobalPlacement !== null
            && player.rankedNetplayProfile.dailyRegionalPlacement !== null;
    }
}

export const RANKS = [
    new NoneRank(),
    new PendingRank(),
    new StandardRank('Bronze I', 0, 765.42, "bg-orange-900", Bronze1Icon),
    new StandardRank('Bronze II', 765.43, 913.71, "bg-orange-900", Bronze2Icon),
    new StandardRank('Bronze III', 913.72, 1054.86, "bg-orange-900", Bronze3Icon),
    new StandardRank('Silver I', 1054.87, 1188.87, "bg-slate-800", Silver1Icon),
    new StandardRank('Silver II', 1188.88, 1315.74, "bg-slate-800", Silver2Icon),
    new StandardRank('Silver III', 1315.75, 1435.47, "bg-slate-800", Silver3Icon),
    new StandardRank('Gold I', 1435.48, 1548.06, "bg-yellow-900", Gold1Icon),
    new StandardRank('Gold II', 1548.07, 1653.51, "bg-yellow-900", Gold2Icon),
    new StandardRank('Gold III', 1653.52, 1751.82, "bg-yellow-900", Gold3Icon),
    new StandardRank('Platinum I', 1751.83, 1842.99, "bg-blue-900", Platinum1Icon),
    new StandardRank('Platinum II', 1843, 1927.02, "bg-blue-900", Platinum2Icon),
    new StandardRank('Platinum III', 1927.03, 2003.91, "bg-blue-900", Platinum3Icon),
    new StandardRank('Diamond I', 2003.92, 2073.66, "bg-sky-900", Diamond1Icon),
    new StandardRank('Diamond II', 2073.67, 2136.27, "bg-sky-900", Diamond2Icon),
    new StandardRank('Diamond III', 2136.28, 2191.74, "bg-sky-900", Diamond3Icon),
    new StandardRank('Master I', 2191.75, 2274.99, "bg-cyan-900", Master1Icon),
    new StandardRank('Master II', 2275, 2350, "bg-cyan-900", Master2Icon),
    new StandardRank('Master III', 2350, Infinity, "bg-cyan-900", Master3Icon),
    new GrandMaster()
];

export function getRank(player: Player) {
    for (let i = RANKS.length - 1; i >= 0; i--)
    {
        if (RANKS[ i ].isRank(player))
        {
            return RANKS[ i ];
        }
    }
    return new NoneRank();
}